@if (dataSourceState$ | async; as dataSourceState) {
    @if (dataSourceState.loading) {
        {{ 'COMMON.LOADING.DATA_SOURCE' | delayDisplay | translate }}
    } @else {
        <div class="flex items-start">
            <mat-form-field
                appearance="outline"
                class="ca-form-field ca-form-field-m ca-form-field-w-full with-label"
                subscriptSizing="dynamic"
                floatLabel="always"
                [attr.aria-label]="ariaLabel()"
                [hideRequiredMarker]="true"
                (blur)="onTouched()"
            >
                @let title = slot().titleKey | translationKey: slot().titleData;
                <mat-label> {{ title }} </mat-label>
                <mat-select
                    [formControl]="control"
                    [disabled]="!!isDisabled"
                    (selectionChange)="onValueChange($event.value)"
                    [value]="value()"
                    [disableOptionCentering]="true"
                    panelClass="ca-dropdown-panel-class"
                >
                    @for (item of dataSourceMapping || dataSourceState.dataSource.items; track item.value) {
                        @let slotLabel = slot().labelKey | translationKey: slot().labelData : item.value;
                        <mat-option [value]="item.value">
                            <div class="flex items-center gap-2">
                                @if (slotLabel) {
                                    <span>{{ slotLabel }}</span>
                                }
                                @if (isVisual) {
                                    <ca-visual [slot]="slot()" [iconSize]="24" [value]="item.value"></ca-visual>
                                }
                            </div>
                        </mat-option>
                    }
                </mat-select>
                @if (isErrorMessage) {
                    <mat-error>
                        <ca-form-error-message>
                            {{ errorMessageTranslation!.key | translationKey: errorMessageTranslation!.data }}
                        </ca-form-error-message>
                    </mat-error>
                }
            </mat-form-field>

            @let tooltip = slot() | slotTooltip;
            @if (tooltip) {
                <div class="flex items-center ms-2 pt-9">
                    <ca-visual [tooltip]="tooltip"></ca-visual>
                </div>
            }
        </div>
    }
}
